<template>
	<div class="ai_container">
		<header class="error_header">
			<img src="/static/images/ai/ai_logo.png" width="170" alt="huckleberry" @click="handleMain" />
		</header>
		<div class="error_body_wrapper">
			<p class="heading_4" style="marginBottom: 16px">결제중 오류가 발생하였습니다.</p>
			<p class="body_6 f_gray_4" style="marginBottom: 72px">

			</p>
			<Button :full="false" :label="'메인으로 가기'" :onClick="handleMain" />
		</div>
		<Footer />
	</div>
</template>

<script>
import Header from "@/components/ai/AiHeader.vue";
import Footer from "@/components/ai/AiFooter.vue";
import Button from "@/components/ai/AiButton.vue";

export default {
	components: {
		Header,
		Footer,
		Button
	},
	methods: {
		handleMain() {
			this.$router.push({ name: "AiMain" });
		}
	}
};
</script>

<style scoped>
.error_header {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 56px;
}

.error_body_wrapper {
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	padding-top: 96px;
	height: calc(100dvh - var(--ai-header-height) - 262px);
}
</style>



// WEBPACK FOOTER //
// src/views/ai/AiError.vue